import React, { useMemo } from 'react';
import { CopyOutlined } from '@duxton-web/icons';
import { Button, Form } from '@duxton-web/ui';
import { JsonView } from 'react-json-view-lite';

import SectionCollapse from '../../common/SectionCollapse';
import {
  useTreatments,
  useVariables,
} from '../../contexts/ExperimentFormInfoProvider';
import { CustomJsonLiteStyles } from '../../helper/consts';
import { convertExperimentFormDataToExperimentPayload } from '../../helper/experiment';

import './index.css';

// eslint-disable-next-line no-empty-pattern
export default function JsonPreview() {
  const form = Form.useFormInstance();
  const [variables] = useVariables();
  const [treatments] = useTreatments();

  const experimentFormData = Form.useWatch([], { form, preserve: true });

  const payload = useMemo(() => {
    if (!experimentFormData) return null;
    if (!variables.length) return null;
    if (!treatments.length) return null;

    const { experiment } = convertExperimentFormDataToExperimentPayload({
      experimentFormData,
      variables,
      treatments,
    });
    return experiment;
  }, [experimentFormData, variables, treatments]);

  return (
    <JsonCard
      title="JSON View"
      subtitle="Preview your experiment"
      style={null}
      payload={payload}
      defaultOpen={false}
    />
  );
}

function Json({ payload }) {
  return (
    <div className="json-preview" style={{ position: 'relative' }}>
      <JsonView
        data={payload}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        shouldInitiallyExpand={(level) => true}
        style={CustomJsonLiteStyles}
      />
      <Button
        shape="circle"
        icon={<CopyOutlined />}
        onClick={() => {
          navigator.clipboard.writeText(JSON.stringify(payload));
        }}
        size="small"
        type="secondary"
        style={{
          position: 'absolute',
          top: 16,
          right: 16,
          // fontSize: 20,
          zIndex: 2,
        }}
      />
    </div>
  );
}

export function JsonCard({ title, subtitle, payload, defaultOpen, style }) {
  const ele = <Json payload={payload} />;

  if (!title) {
    return ele;
  }

  return (
    <SectionCollapse
      style={style}
      title={title}
      subtitle={subtitle}
      defaultOpen={defaultOpen}
    >
      {ele}
    </SectionCollapse>
  );
}
